import { NavLink } from "react-router-dom";

export default function FeaturedInItem({ article, size }) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <>
      <div className="max-w-7xl py-8 border-t border-gray-200 mx-auto flex flex-col md:flex-row items-start gap-8">
        <div
          className="relative md:w-1/3 w-full md:pt-0 pt-60 bg-no-repeat bg-center bg-cover md:bg-none"
          style={{
            backgroundImage: `url(${article?._embedded["wp:featuredmedia"][0]?.source_url})`,
          }}
        >
          <div className="overflow-hidden md:block hidden h-full">
            <img
              src={article?._embedded["wp:featuredmedia"][0]?.source_url}
              alt={article?.title?.rendered}
              className={`min-h-52 w-auto aspect-[16/9] bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2] transition duration-700 ease-in-out transform hover:scale-110`}
            />
          </div>
        </div>
        <div className="relative md:w-2/3 w-full">
          <div className="text-lg mb-2 text-[#58b947] font-medium">
            <span
              dangerouslySetInnerHTML={{
                __html:
                  new Date(article.date).getDate() +
                  " " +
                  monthNames[new Date(article.date).getMonth()] +
                  " " +
                  new Date(article.date).getFullYear(),
              }}
            />
          </div>

          <h3 className="font-normal md:text-2xl text-lg">
            <span
              dangerouslySetInnerHTML={{
                __html: article?.title?.rendered,
              }}
            />
          </h3>
          <div
            dangerouslySetInnerHTML={{
              __html: article?.content?.rendered?.replace(
                /<p.*?>/g,
                "<p class='mb-5'>",
              ),
            }}
          />
        </div>
      </div>
    </>
  );
}
